/** @jsxRuntime classic */
/** @jsx jsx */
import { Col, Container } from '@bottlebooks/gatsby-theme-base';
import { graphql } from 'gatsby';
import gql from 'graphql-tag';
import { jsx } from 'theme-ui';
import BrandDetailsSection from '../Brand/BrandDetailsSection';
import BrandDistributors from '../Brand/BrandDistributors';
import ContentRow from '../ContentRow';
import ExhibitorContacts from './ExhibitorContacts';

/**
 * A component to contain all the exhibitor details sections.
 * It can be used to prepend or append some content in shadowed components.
 * @param {object} props
 * @param {object} props.exhibitor The exhibitor.
 * @param {string} props.eventId The event id.
 * @returns
 */
export default function ExhibitorSections({ exhibitor, eventId, ...rest }) {
  return (
    <Container {...rest}>
      <ContentRow>
        <Col flex>
          <ExhibitorContacts
            exhibitor={exhibitor}
            eventId={eventId}
            sx={{ flex: '1 0 auto' }}
          />
        </Col>
      </ContentRow>
      <ContentRow>
        <BrandDetailsSection brand={exhibitor} />
      </ContentRow>
      <ContentRow>
        <Col flex>
          <BrandDistributors brand={exhibitor} />
        </Col>
      </ContentRow>
    </Container>
  );
}

export const fragment = graphql`
  fragment bb_ExhibitorSections_RegisteredBrand on Bottlebooks_RegisteredBrand {
    distributionContacts {
      ...bb_Contact
    }
    ...bb_BrandDetailsSection_RegisteredBrand
  }
  fragment bb_ExhibitorSections on Bottlebooks_AbstractBrand {
    ...bb_BrandDetailsSection
    ...bb_BrandDistributors
  }
  fragment bb_Registration on Bottlebooks_Registration {
    ... on Bottlebooks_SingleRegistration {
      profile {
        name
      }
      ...bb_Registration_Contacts
    }
  }
`;

ExhibitorSections.fragment = gql`
  fragment ExhibitorSections on AbstractBrand {
    ...BrandDetailsSection
  }
  ${BrandDetailsSection.fragment}
`;
